import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  container: {
    borderRadius: theme.sizes.roundCorners,
    backgroundColor: theme.colors.panel_background,
    overflow: 'hidden'
  }
});

export default makeStyles(styles);
